import {
  array,
  type BaseIssue,
  boolean,
  fallback,
  flatten,
  gtValue,
  minLength,
  nullish,
  number,
  object,
  optional,
  pipe,
  record,
  string,
  transform,
  union,
} from 'valibot';
import { Errors } from '../../../common/texts';

export const numberStringPositive = (error: string) =>
  pipe(union([string(), number()]), transform(Number), number(), gtValue(0, error));

export const numberStringPositiveWithFallback = (error: string, fallbackValue: number) =>
  fallback(numberStringPositive(error), fallbackValue);

export const IntermodalGoodsFormModelSchema = object({
  goodsType: object(
    { id: string(), code: string(), description: string() },
    Errors.IntermodalGoodsTypeRequired,
  ),
  weight: numberStringPositive(Errors.IntermodalGoodsWeightRequired),
  id: string(),
  created: optional(boolean()),
});

const commonFields = {
  route: object({ id: string() }, Errors.IntermodalRouteRequired),
  customer: object({ custNo: number() }, Errors.IntermodalAccountRequired),
  departureDate: pipe(string(), minLength(1, Errors.IntermodalDateRequired)),
  departureTime: pipe(string(), minLength(1, Errors.IntermodalTimeRequired)),
  vehicleType: object({ code: string() }, Errors.IntermodalVehicleTypeRequired),
  noOfPlugins: number(),
  length: numberStringPositive(Errors.IntermodalLengthRequired),
  width: numberStringPositive(Errors.IntermodalWidthRequired),
  height: numberStringPositive(Errors.IntermodalHeightRequired),
  emptyWeight: numberStringPositive(Errors.IntermodalEmptyWeightRequired),
};

const updateAndCreateFields = {
  ...commonFields,
  vehicleReg: string(),
  iluCode: string(),
  craneable: boolean(),
  hazardousGoods: boolean(),
  noOfPlugins: number(),
  temperature: string(),
  customerReference: string(),
  loadingNote: string(),
};

const IntermodalLegFormModelSchema = object({
  legNumber: number(),
  id: string(),
});

export const CreateIntermodalFormModelSchema = object({
  ...updateAndCreateFields,
  legs: nullish(array(IntermodalLegFormModelSchema)),
  searchByDeparture: boolean(),
  bookingGoods: record(string(), IntermodalGoodsFormModelSchema),
});

export const UpdateIntermodalFormModelSchema = object({
  ...updateAndCreateFields,
  bookingNo: number(),
  bookingGoods: record(string(), IntermodalGoodsFormModelSchema),
});

export const IntermodalJourneyFormModelSchema = object({
  ...commonFields,
  searchByDeparture: boolean(),
  bookingGoods: record(
    string(),
    object({ weight: numberStringPositiveWithFallback(Errors.IntermodalGoodsWeightRequired, 0) }),
  ),
});

export const collectIssues = (
  issues: [BaseIssue<unknown>, ...BaseIssue<unknown>[]],
): Record<string, string[] | undefined> => flatten(issues).nested ?? {};
